import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { environment } from '@environment/environment';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

export interface FrontendConfig {
	[key: string]: unknown;
}

@Injectable({
	providedIn: 'root',
})
export class ConfigService {
	private readonly configUrl = `${environment.pathBackend}/health/config`;
	private config = signal<FrontendConfig | null>(null);
	private configLoaded = signal<boolean>(false);

	constructor(private http: HttpClient) {}

	loadConfig(): Observable<FrontendConfig> {
		const currentConfig = this.config();
		if (this.configLoaded() && currentConfig) {
			return of(currentConfig);
		}

		return this.http.get<FrontendConfig>(this.configUrl).pipe(
			tap((config) => {
				this.config.set(config);
				this.configLoaded.set(true);
			}),
			catchError((error) => {
				console.error('Error loading config from backend, using defaults:', error);
				const defaultConfig: FrontendConfig = {};
				this.config.set(defaultConfig);
				this.configLoaded.set(true);
				return of(defaultConfig);
			}),
		);
	}

	isConfigLoaded(): boolean {
		return this.configLoaded();
	}
}
